import qs from "qs";
import request from "@/utils/requestSC";

// 查询签收单详情
export async function queryElectronicReceipt(params) {
  return request.get("/rest/order/queryElectronicReceipt", {
    params
  });
}

// 代收单分页列表查询
export async function queryListForPage(params) {
  return request.post("/rest/order/behalfReceive/queryListForPage", params);
}

// 图片智能识别验证
export async function checkUploadOrderVoucher(params) {
  return request.post("/rest/order/checkUploadOrderVoucher", qs.stringify(params));
}

// 确认签署
export async function signElectronicReceipt(params) {
  return request.post("/rest/order/signElectronicReceipt", params);
}

// 判断当前订单关联的货联运单是否起运
export async function getOrderQyPassed(params) {
  return request.get("/rest/order/orderQyPassed", {
    params
  });
}

// 确认收货
export async function receiptOrderGoods(params) {
  return request.post("/rest/order/receiptOrderGoods", params);
}

// 判断当前登录人身份
export async function signCheckReceiptUser(params) {
  return request.get("/rest/order/signCheckReceiptUser", {
    params
  });
}

// 签收单详情（运营后台使用）
export async function queryElectronicReceiptByOrderId(params) {
  return request.get("/rest/order/queryElectronicReceiptByOrderId", {
    params
  });
}

// 合同详情（运营后台使用）
export async function querySignElectronicReceipt(params) {
  return request.get("/rest/contract/queryElectronicReceipt", {
    params
  });
}

// 合同详情（运营后台使用）
export async function toSignElectronicReceipt(params) {
  return request.get("/rest/contract/toSignElectronicReceipt", {
    params
  });
}
